:host {
  display: block;
  width: 404px;
  height: 70vh;

  @media (max-width: 768px) {
    width: 100vw;
  }

  .news {
    height: 100%;
    display: flex;
    flex-direction: column;
    line-height: initial;

    .scroll {
      flex: 0 1 auto;
      max-height: 70vh;
      min-height: 210px;
      overflow-y: scroll;
      overflow-x: hidden;
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #e0e0e0;
        background-color: var(--divider);
        border-radius: 10px;
      }
      scrollbar-color: var(--divider) transparent;
      scrollbar-width: thin;
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px 24px 0;
      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 18px;
        font-weight: 500;
        color: var(--font-primary);
        .bg-icon {
          display: flex;
          align-items: baseline;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 4px;
          background-color: var(--bg-blue-manager);
          img {
            width: 15px;
          }
        }
        .unseen-count {
          display: none; // display none until we need again to have this events block information
          padding: 3px 8px;
          background: var(--bg-blue-manager);
          border-radius: 38px;
          font-size: 14px;
          font-weight: 500;
          color: var(--blue);
        }
      }
      .cross-icon {
        color: var(--svg-primary-fill);
        display: none;
        cursor: pointer;
        @media all and (max-width: 767px) {
          display: block;
        }
      }
    }

    &__events {
      display: none; // display none until we need again to have this events block information
      padding: 0 16px 24px;

      .events-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        background: var(--bg-blue-manager);
        border-radius: 6px;
        .events-content {
          display: flex;
          align-items: center;
          gap: 8px;
          color: var(--font-primary);
          font-weight: 500;
        }
        a {
          color: var(--blue-link);
          text-decoration: none;
          font-size: 14px;
          font-weight: 400;
        }
      }
    }

    &__tabs {
      display: none; // display none until we need again to have multi tabs (news, notif, incidents..)
      //display: flex;
      align-items: center;
      gap: 24px;
      padding: 0 24px 0;
      border-bottom: 1px solid var(--divider);
      .tab {
        padding-bottom: 8px;
        font-size: 14px;
        font-weight: 400;
        color: var(--font-secondary);
        cursor: pointer;
        &.active {
          position: relative;
          font-weight: 500;
          color: var(--blue);
          &:after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 0;
            right: 0;
            background: var(--blue);
            height: 2px;
            border-radius: 10px;
          }
        }
        span {
          padding: 3px 7px;
          background: var(--bg-blue-manager);
          border-radius: 38px;
          margin-left: 8px;
          font-size: 12px;
          &.has-events {
            background: #ff8500;
            color: #fff;
          }
        }
      }
    }
  }
}
